import { useEffect, useState } from "react";
import {
  getAsset,
  getLabel,
  shouldShowSponsorship,
} from "../../../utils/appConfig";
import CategorySelection from "./CategorySelection";
import { useNavigate } from "react-router-dom";
import useStore from "../../../store/useStore";

const SplashScreen = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [showNextComponent, setShowNextComponent] = useState(false);
  const [preferences, setPreferences] = useState<number[]>([]);
  const navigate = useNavigate();
  const { planDetails, tatvaShots } = useStore();
  const { shot_plan, isSelfShotsPlan } = planDetails || {};
  const { service_payer } = shot_plan || {};
  // Get the appropriate logo based on app configuration
  const shotsLogo = getAsset("shots");
  const shotsLabel = getLabel("shotsLabel");
  // Check if we should show sponsorship information
  const showSponsorship = shouldShowSponsorship();

  useEffect(() => {
    // Start the animation after a short delay
    const timer = setTimeout(() => {
      setIsAnimating(true);
    }, 500); // Delay to allow initial render

    // Once animation is done, show the next component
    const animationDuration = 1000; // Match this to your animation duration
    const nextComponentTimer = setTimeout(() => {
      setShowNextComponent(true);
    }, animationDuration);

    return () => {
      clearTimeout(timer);
      clearTimeout(nextComponentTimer);
    }; // Cleanup timers on unmount
  }, []);

  useEffect(() => {
    if (tatvaShots?.userPreferences?.length) {
      navigate("/tatva-shots-home");
    }
  }, [tatvaShots]);

  return (
    <div className="relative w-full h-screen bg-white flex items-center justify-center overflow-hidden">
      {!showNextComponent ? (
        <div
          className={`transition-all duration-700 ease-in-out
        ${
          isAnimating
            ? "transform -translate-x-[calc(50vw-100px)] -translate-y-[calc(50vh-50px)] scale-75"
            : "scale-100"
        }`}
          style={{ transitionTimingFunction: "ease-in-out" }}
        >
          <div className="flex flex-col items-center text-xs leading-6 text-center text-gray-800">
            <img
              loading="lazy"
              src={shotsLogo}
              alt={shotsLabel}
              className="w-[264px] object-contain"
            />
            {showSponsorship && !isSelfShotsPlan && service_payer?.containerName && (
              <div className="flex items-center text-center font-normal leading-[32.81px] text-[16.4px]">
                <div className="self-stretch my-auto">Sponsored By</div>
                <img
                  loading="lazy"
                  src={service_payer?.containerName}
                  className="object-contain shrink-0 self-stretch my-auto aspect-[2.44] w-[70px]"
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <CategorySelection
          preferences={preferences}
          setPreferences={setPreferences}
        />
      )}
    </div>
  );
};

export default SplashScreen;
